<template>
  <div class="login-page">
    <el-tabs type="border-card" v-model="activeTab" @tab-click="TabsClick" ref="tabs" class="login-container"
      :style="{ top: formtop }">
      <el-tab-pane label="密碼登錄" name="actpsw" v-if="pswLogin()">
        <el-form label-width="70px" :inline="true" status-icon :model="form" :rules="rules" ref="form">
          <h3 class="login-title">公司系統</h3>
          <el-form-item label="账号" prop="account">
            <el-input prefix-icon="el-icon-user-solid" v-model="form.account" autocomplete="off" placeholder="請輸入账号">
            </el-input>
          </el-form-item>
          <el-form-item label="密码" prop="password">
            <el-input prefix-icon="el-icon-lock" type="password" autocomplete="off" v-model="form.password"
              placeholder="請輸入密码"></el-input>
          </el-form-item>
          <el-form-item label=" ">
            <el-button round @click="submit" size="medium" type="primary" style="width: 130px; margin-top: 10px"
              @keyup.enter="keyDown(e)">登录</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <el-tab-pane label="掃碼登錄" name="qrcode" v-if="qrLogin()">
        <img style="width: 100%;" :src="qrcodeUrl" alt="Qr Code" />
      </el-tab-pane>
    </el-tabs>

  </div>
</template>
<script>
import Cookie from "js-cookie";
import { UserLogin, GetQrCode, QrCodeLogin } from "@/api/rms86/login";
import { Sys_lookup } from "@/api/rms86/home";
export default {
  data() {
    return {
      form: {
        account: "",
        password: "",
      },
      rules: {
        account: [{ required: true, message: "請輸入账号", trigger: "blur" }],
        password: [{ required: true, message: "請輸入密码", trigger: "blur" }],
      },
      formtop: "100px",
      activeTab: (login_type == 2 || login_type == 3) ? "actpsw" : "qrcode",
      qrTimer: null,
      frontid: "6d4415ee-72dc-4a55-8fce-f1ee15177e9b",
      qrcodeUrl: "",
    };
  },
  methods: {
    // 登录
    submit() {
      //  校验通过
      this.$refs.form.validate((valid) => {
        if (valid) {
          // 获取指定后台{data}对象
          UserLogin(this.form).then((data) => {
            if (data.success === 1) {
              this.InitMenu()
              // 跳转至首页
              this.$router.push({ name: "main" });
            } else {
              this.$message.error(data.message);
            }
          });
        }
      });
    },
    //輪詢檢查掃碼結果
    scanResult() {
      if(this.frontid == "")
        return;
      QrCodeLogin({ params: { frontid: this.frontid } }).then(res => {
        if (res.success == 1) {
          this.InitMenu()
          // 跳转至首页
          this.$router.push({ name: "main" });
        }
      });
    },
    // 登录后加载菜单数据
    InitMenu() {
      Sys_lookup().then((data) => {
        var menu = {
          path: "/home",
          name: "home",
          label: "首頁",
          icon: "menu",
          url: "home/index",
          acode: "",
        };
        data.push(menu);
        // 获取登录后菜单数据，存入store中
        this.$store.commit("setMenu", data);
        this.$store.commit("addMenu", this.$router);
      });
    },
    // 点击回车键登录
    keyDown(e) {
      // 回车则执行登录方法 enter键的ASCII是13
      if (e.keyCode == 13 || e.keyCode == 100) {
        this.submit();
      }
    },
    windowresize(e) {
      this.formtop = parseInt((document.body.clientHeight - this.$refs.tabs.$el.clientHeight) / 2) + "px";
    },
    async TabsClick(tab, event) {
      if (tab.name === "actpsw") {
        window.addEventListener("keydown", this.keyDown);
        clearTimeout(this.qrTimer);
      }
      else {
        window.removeEventListener("keydown", this.keyDown, false);
        //產生二維碼
        var res = await GetQrCode();
        if(res.errcode == 0) {
          this.frontid = res.message;
          this.qrcodeUrl = res.errmsg;
        }
        else {
          this.$message.error(res.errmsg);
        }
        this.qrTimer = setInterval(() => {
          this.scanResult();
        }, 2000);
      }
    },
    pswLogin() {
      return login_type == 2 || login_type == 3
    },
    qrLogin() {
      return login_type == 1 || login_type == 3
    },
  },
  async mounted() {
    // 绑定监听事件
    if (this.activeTab === "actpsw") {
      window.addEventListener("keydown", this.keyDown);
    }
    else {
      var res = await GetQrCode();
        if(res.errcode == 0) {
          this.frontid = res.message;
          this.qrcodeUrl = res.errmsg;
        }
        else {
          this.$message.error(res.errmsg);
        }
        this.qrTimer = setInterval(() => {
          this.scanResult();
        }, 2000);      
    }
    window.addEventListener("resize", this.windowresize);
    this.formtop = parseInt((document.body.clientHeight - this.$refs.tabs.$el.clientHeight) / 2) + "px";
  },
  destroyed() {
    // 销毁事件
    if (this.activeTab === "actpsw") {
      window.removeEventListener("keydown", this.keyDown, false);
    }
    else {
      clearTimeout(this.qrTimer);
    }
    window.removeEventListener("resize", this.windowresize);
  },
};
</script>
<style lang="less" scoped>
.login-page {
  background-image: url("@/assets/images/rms86_login.png");
  background-size: cover;
  height: 100%;

  .login-container {
    max-width: 420px;
    border: 1px solid #eaeaea;
    margin: auto;
    position: relative;
    //top: 34%;
    padding: 35px 35px 15px 35px;
    background-color: #fff;
    border-radius: 15px;
    box-shadow: 0 0 25px #cac6c6; //圆角阴影
    box-sizing: border-box; //内边距

    .login-title {
      text-align: center;
      margin-bottom: 40px;
      color: #505458;
    }

    .el-input {
      max-width: 260px;
    }
  }
}
</style>
